import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

import { getLandlord } from 'actions/landlordUserActions';
import { postLead } from 'actions/landlordLeadsActions';

import { CSSTransitionGroup } from 'react-transition-group';

import LeadDetailsForm from 'components/shared/LeadDetailsForm';

export default connect(
  store => ({
    accentColor: store.userTypes.accentColor,
  }),
  { getLandlord, postLead }
)(
  class LeadCapture extends Component {
    constructor(props) {
      super(props);
      this.state = {
        formSubmitSuccess: false,
      };
    }

    componentDidMount() {
      const query_params = browserHistory.getCurrentLocation().query;
      this.props.getLandlord(query_params.landlord_id);
    }

    submitLeadDetails = formData => {
      return this.props
        .postLead(formData, browserHistory.getCurrentLocation().query.landlord_id)
        .then(() => {
          this.setState({ formSubmitSuccess: true });
        });
    };

    render() {
      return (
        <div className="container application-container">
          <CSSTransitionGroup
            transitionName="fade_out"
            transitionEnterTimeout={200}
            transitionAppear={true}
            transitionAppearTimeout={500}
            transitionLeaveTimeout={200}
          >
            {this.renderForm()}
            {this.renderSuccess()}
          </CSSTransitionGroup>
        </div>
      );
    }

    renderForm() {
      if (this.state.formSubmitSuccess) return null;

      return (
        <div>
          <h3
            style={{
              textAlign: 'center',
              fontSize: '30px',
              marginBottom: '10px',
            }}
          >
            Provide your details below to learn more.
          </h3>
          <div>
            <div className="row" style={{ textAlign: 'center' }}>
              <LeadDetailsForm
                onSubmit={this.submitLeadDetails}
                labelText="Find Out More Details"
                accentColor={this.props.accentColor}
              />
            </div>
          </div>
        </div>
      );
    }

    renderSuccess() {
      if (!this.state.formSubmitSuccess) return null;
      return (
        <div>
          <h3
            style={{
              textAlign: 'center',
              fontSize: '30px',
              marginBottom: '10px',
            }}
          >
            We have successfully received your information. We will be in touch shortly.
          </h3>
        </div>
      );
    }
  }
);
